import type {
  ThemeOptions,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';

import { type Theme } from '../ThemeRegistry/theme.types';

const defaultProps: ComponentsProps['Accordion'] = {};

const styleOverrides: ComponentsOverrides<Theme>['Accordion'] = {
  root: ({ theme, ownerState }) => ({
    //...theme.mixins.applyBackgroundColor({ ownerState, theme }),
    containerType: 'inline-size',
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--grid-gap)'
  }),

  introTextGrid: () => ({
    marginBottom: 'var(--grid-gap-double)'
  }),

  introText: {
    gridColumn: 'start / end',
    textAlign: 'center'
  },

  contentOuterGrid: {
    '> *': {
      gridColumnStart: 'start',
      gridColumnEnd: 'end'
    },
    'gridGap': 0
  },

  accordionItem: () => ({
    'border': 'none',
    'borderRadius': 0,
    'backgroundColor': 'transparent',
    'boxShadow': 'none',
    'marginBottom': 'var(--grid-gap)',
    'padding': 0,

    '&:before': {
      display: 'none'
    },

    '&:last-child': {
      marginBottom: 0
    }
  }),

  summaryWrap: ({ theme }) => ({
    'minHeight': 'unset',
    'padding': 'var(--grid-gap) 0',
    'borderTop': `1px solid ${theme.palette.divider}`,
    'borderBottom': `1px solid ${theme.palette.divider}`,

    '&.Mui-expanded': {
      minHeight: 'unset'
    },

    '&:hover': {
      cursor: 'pointer'
    }
  }),

  summary: ({ theme }) => ({
    'fontSize': 'var(--h4-font-size)',
    'lineHeight': 'var(--h4-line-height)',
    'fontWeight': 'var(--h4-font-weight)',
    'margin': 'var(--h4-margin)',
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'space-between',
    'gap': 'var(--grid-gap)',
    'color': theme.palette.text.primary,

    '&.Mui-expanded': {
      margin: 0
    }
  }),

  detailsWrap: () => ({
    padding: 'var(--grid-gap-double) 0'
  }),

  details: ({ theme }) => ({
    fontSize: 'var(--body1-font-size)',
    lineHeight: 'var(--body1-line-height)',
    fontWeight: 'var(--body1-font-weight)',
    margin: 'var(--body1-margin)',
    color: theme.palette.text.secondary
  })
};

const createVariants = (_theme: Theme): ComponentsVariants['Accordion'] => [];

export const AccordionTheme = (theme: Theme): ThemeOptions => ({
  components: {
    Accordion: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default AccordionTheme;
